import { getUserInfo } from '@/apis/auth';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { useAuthStore } from '@/stores';
import { UserResponse } from '@/types/auth';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useGetUserInfoQuery = () => {
  const { login } = useAuthStore();

  const query = useQuery<UserResponse>({
    queryKey: [QUERY_KEYS.userInfo],
    queryFn: () => getUserInfo(),
    throwOnError: true,
  });

  useEffect(() => {
    const res = query.data;
    if (!res) return;

    login(
      {
        studentId: res.studentId,
        studentName: res.studentName,
        studentType: res.studentType,
      },
      res.currentSemester,
      res.term,
    );
  }, [login, query.data]);

  return query;
};

export default useGetUserInfoQuery;
